import { render } from "./Autocomplete.vue?vue&type=template&id=31b01510&scoped=true"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=31b01510&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b01510"]])

export default __exports__